export const SectionHeading = ({ index, label, title, dark = false, shortenRule = false, terra = false }) => {
  const slug = label.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  const tickColor = terra ? "bg-sand/40" : dark ? "bg-sand/30" : "bg-ink/25";
  const rowColor = terra ? "text-sand/70" : dark ? "text-[#C9CDC0]" : "text-muted";
  const numColor = terra ? "text-sand" : dark ? "text-[#C96A63]" : "text-terracotta";
  const ruleColor = terra ? "bg-sand/25" : dark ? "bg-sand/20" : "bg-ink/15";
  const titleColor = terra || dark ? "text-sand" : "text-ink";
  return (
    <div data-testid={`section-heading-${slug}`}>
      <div
        className={`flex items-center gap-3 text-xs font-medium uppercase tracking-[0.2em] ${rowColor}`}
      >
        <span className={`font-bold ${numColor}`}>{index}</span>
        <span aria-hidden="true" className="opacity-50">
          /
        </span>
        <span>{label}</span>
        <span
          aria-hidden="true"
          className={`relative h-px flex-1 ${ruleColor} ${
            shortenRule ? "mr-[150px] sm:mr-[180px]" : ""
          }`}
        >
          <span className={`absolute -top-[3px] left-0 h-[7px] w-px ${tickColor}`} />
          <span className={`absolute -top-[3px] right-0 h-[7px] w-px ${tickColor}`} />
        </span>
      </div>
      {title && (
        <h2
          className={`mt-6 max-w-3xl text-3xl font-bold tracking-tight sm:text-4xl ${titleColor}`}
        >
          {title}
        </h2>
      )}
    </div>
  );
};
